import axios from "@/plugins/axios";

import keywordSearches from "./keyword-searches";
import links from "./links";
import categories from "./categories";

let url = "/api/console/manufacturing/materials";

export const materials = {
    categories,
    keywordSearches,
    links,

    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },
    post(data) {
        return axios.post(url, data).then((result) => result.data);
    },
    postSync(data) {
        return axios.post(`${url}/sync`, data).then((result) => result.data);
    },
    put(data) {
        return axios.put(`${url}/${data._id}`, data).then((result) => result.data);
    },
    delete(data) {
        return axios.delete(`${url}/${data._id}`).then((result) => result.data);
    },
};

export default materials;
